import React, { useState,useRef, useEffect } from 'react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import { Avatar, Stack } from '@chakra-ui/react'
import { Mail, MessageCircle, Handshake, Newspaper, Search,EllipsisVertical, Link } from 'lucide-react';
import { getVendorListById } from '../../../redux/api/vendorApi/VendorApi.js';
import { useLocation, useNavigate } from 'react-router-dom';
export default function PaymentReceiveDetails() {
    //for adding scrollbar in tablist
    const tabListRef = useRef(null);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const id = location.state?.ROWID || "";
    const [item, setitem] = useState(null);

    const navigate = useNavigate();
    const onBack =()=> navigate(-1);
    useEffect(() => {
       console.log(location)
        console.log({ id })
        getVendorListById(id).then((response) => {
            if (response.data.success ) {
                setitem(response.data.vendor[0]);
            }
        }).catch((error) => {
            console.log({ error });
        });
    }, [id]);

    useEffect(() => {
        console.log({ item })
    }, [item])

    const toggleDropdown = () => setIsOpen(prevState => !prevState);

    const handleTouchStart = (e) => {
      setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
      setTouchEndX(e.touches[0].clientX);
    };
    const handleTouchEnd = () => {
        if (tabListRef.current) {
          const distance = touchStartX - touchEndX;
    
          if (distance > 50) {
            // Swipe left to scroll right
            tabListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
          } else if (distance < -50) {
            // Swipe right to scroll left
            tabListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
          }
        }
      };
    return (
        <div className='custom-scroll' style={{ minHeight: '88vh' }}>
            <Tabs variant='enclosed'>
                <TabList ref={tabListRef} className="vendor-custom-tablist" onTouchStart={handleTouchStart} onTouchMove = {handleTouchMove} onTouchEnd = {handleTouchEnd}>
                    <Tab>Overview</Tab>
                  
                </TabList>
                <TabPanels>
                    {/* Overview panel */}
                    <TabPanel className='vendor-customScroll'  style={{ maxHeight: "72vh",width:"100%", position: "relative", overflowY: "scroll" ,overflowX:'hidden', scrollbarColor: '#A0AEC0 #EDF2F7',
    scrollbarWidth: '10px'  }} >
          
                                            <button onClick={()=>onBack()} className='create-button py-1' >Back</button>
                                        
                        <div>
                            {/* Profile div  */}
                            <div className='wrapper card card-detail PaymentReceiveDetails mt-3'>
                                <div className='d-flex justify-content-between ' style={{ marginLeft: '14px' }} >
                                    <div className='col-lg-2 col-md-12 col-3  mt-3' >
                                        <Stack direction='row' >
                                            {/* <Avatar size='xl' name='Prosper Otemuyiwa' src='https://i.imgur.com/CctsEUU.jpeg'  boxSize={{base: '80px', xl: '100px'}} /> */}
                                                               <Avatar
                    size="xl"
                    // name="Christian Nwamba"
                    name =  {item?.customerName || 'NA'}
                    src="https://bit.ly/code-beast"
                    boxSize={{ base: "80px", xl: "100px" }}
                    />
                                        </Stack>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-7 mt-4 vendorName'>
                                        <h4 style={{ color: "#023233" }}>{item?.customerName || 'NA'}</h4>
                                        <p>Payment Receive</p>
                                        {/* for mobile icons starts */}
                                        <div className="div d-lg-none">
                                        <div className="div d-flex ">
                                            <Mail color='#ff176b' strokeWidth="1" className='ms-1 vendorphoneIcon'/>
                                            <MessageCircle color='#ff176b' strokeWidth="1" className='ms-2 vendorphoneIcon'/>
                                            <Handshake color='#ff176b' strokeWidth="1" className='ms-2 vendorphoneIcon'/>
                                            <Newspaper color='#ff176b' strokeWidth="1" className='ms-2 vendorphoneIcon'/>
                                            </div>
                                        </div>
                                        {/* for mobile icons ends */}


                                    </div>
                                    <div className='col-lg-4 col-md-12 col-2 mt-3'>
                                        <div className='d-flex gap-3 mt-3 vendorCreateBtn'>
                                            {/* <Link to ="/convert-to-deal">
                     <button className='create-button py-1'>Convert to deal</button>
                    </Link> */}
                    

                                             {/* for phone EllipsisVertical  start */}
                                                <div className="dropdown d-lg-none"> 
                                                <button className="dealElippsebtn " data-bs-toggle="dropdown" aria-expanded="false" >
                                                    <EllipsisVertical style= {{marginTop: '-30px'}}/>
                                                </button>

                                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                                    <li>
                                                    <a className="dropdown-item" href="#"> Convert to Proposal</a>
                                                    <a className="dropdown-item" href="#" > Edit</a>
                                                    <a className="dropdown-item" href="#" > Delete </a>
                                                    </li>
                                                </ul>
                                                </div>
                                             {/* for phone EllipsisVertical  end*/}

                                    <div className="div d-none d-sm-block ">
                                        <div className="div d-flex ">
                                            <Mail color='#ff176b' strokeWidth="1" className='ms-1' />
                                            <MessageCircle color='#ff176b' strokeWidth="1" className='ms-1' />
                                            <Handshake color='#ff176b' strokeWidth="1" className='ms-1'/>
                                            <Newspaper color='#ff176b' strokeWidth="1" className='ms-1'/>
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Profile div  end */}
                            {/* Below content  */}
                            <h6 style={{ color: "#767272", marginLeft:"10px",marginTop:"8px"}}>Payment Receive Informtaion</h6>
                            <div class="wrapper mt-1">
                                <div class="row g-3">
                                    <div class="col-lg-6 col-md-12 align-items-stretch">
                                        <div class="card card-detail p-0">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive table-div1">
                                                    <table class="table table-space ">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Customer Name</th>
                                                            <td className='font-color'>{item?.customerName || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Amount Received</th>
                                                            <td className='font-color'>{item?.amountReceived || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Payment Date</th>
                                                            <td className='font-color'>{item?.paymentDate || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Payment#</th>
                                                            <td className='font-color'>{item?.payment || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Payment Mode </th>
                                                            <td className='font-color'>{item?.paymentMode || 'NA'}</td>
                                                        </tr>
                                                         <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Deposite To </th>
                                                            <td className='font-color'>{item?.depositeTo || 'NA'}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                              <h6 className="ps-2 mt-3" style={{ color: "#767272" }}>Item Table</h6>
                             {/* <div className='row'>
                                <div className='col-lg-12 col-md-12 col-12 mb-2' >
                                <table className="table table-bordered" >
                                    <thead>
                                        <tr>
                                             <th>Date</th>
                                             <th>Invoice Number</th>
                                             <th>Invoice Amount</th>
                                             <th>Amount Due</th>
                                             <th>Payment Received On</th>
                                             <th>Payment</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="border-radius:none;">01 Mar 2023</td>
                                           <td>HR-80/23-24</td>
                                           <td>25,712.93</td>
                                           <td>25,712.93</td>
                                           <td>29 Jul 2025</td>
                                           <td>Cash</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                             </div> */}
                             <div className='row'>
  <div className='col-lg-12 col-md-12 col-12 mb-2'>
    <table className="table table-bordered text-black">
      <thead>
        <tr>
          <th className='text-black'>Date</th>
          <th  className='text-black'>Invoice Number</th>
          <th className='text-black'>Invoice Amount</th>
          <th className='text-black'>Amount Due</th>
          <th className='text-black'>Payment Received On</th>
          <th className='text-black'>Payment</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className='font-color' style={{ borderRadius: 0 }}>01 Mar 2023</td>
          <td className='font-color' style={{ borderRadius: 0 }}>HR-80/23-24</td>
          <td className='font-color' style={{ borderRadius: 0 }}>25,712.93</td>
          <td className='font-color' style={{ borderRadius: 0 }}>25,712.93</td>
          <td className='font-color' style={{ borderRadius: 0 }}>29 Jul 2025</td>
          <td className='font-color' style={{ borderRadius: 0 }}>Cash</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>




    {/* <h6 style={{ color: "#767272", marginLeft:"10px",marginTop:"8px"}}>Payment Receive Informtaion</h6> */}
                            <div class="wrapper mt-1">
                                <div class="row g-3">
                                    
                                    <div class="col-lg-6 col-md-6 align-items-stretch">
                                        <div class="card card-detail p-0">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive table-div1">
                                                    <table class="table table-space ">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight '>Total</th>
                                                            <td className='font-color'>234</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight '>Amount Received </th>
                                                            <td className='font-color'>456</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight '>Amount used for Payments </th>
                                                            <td className='font-color'>678</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight '>Amount Refunded</th>
                                                            <td className='font-color'>6789</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight '>Amount in Excess</th>
                                                            <td className='font-color'></td>
                                                        </tr>
                                                       
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>



                              
                                {/* <h6 className="ps-3" style={{ color: "#767272" }}>Description</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12 col-12 mb-2">
                                        <div className="card card-detail px-0">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.description || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                           
                        </div>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </div>
    )
}
